function getDeliveryDate() {
  const daysOfWeek = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
  const monthsOfYear = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
  
  // Obteniendo la fecha y hora actual en la zona horaria de México
  let today = luxon.DateTime.now().setZone('America/Mexico_City').toISO();
  today = new Date(today);

  /*let today = luxon.DateTime.fromObject({ year: 2024, month: 11, day: 3, hour: 9, minute: 36 }).setZone('America/Mexico_City').toISO();;
  today = new Date(today);*/

  const currentHour = today.getHours();
  const currentMinutes = today.getMinutes();
  const currentDay = today.getDay(); 

  let deliveryDate = new Date(today);

  // Lunes a Jueves antes de las 2:00 PM - entrega hoy mismo
  if (currentDay >= 1 && currentDay <= 4) { 
    if (currentHour < 14 || (currentHour === 14 && currentMinutes === 0)) {
      return "hoy mismo";
    } else {
      // Lunes a Jueves después de las 2:00 PM - entrega al día siguiente
      deliveryDate.setDate(today.getDate() + 1);
    }
  }

  // Viernes antes de las 2:00 PM - entrega hoy mismo
  if (currentDay === 5 && (currentHour < 14 || (currentHour === 14 && currentMinutes === 0))) {
    return "hoy mismo";
  }

  // Viernes después de las 2:00 PM - entrega el sábado
  if (currentDay === 5 && currentHour >= 14) {
    deliveryDate.setDate(today.getDate() + 1);
  }

  // Sábado antes de las 10:00 AM - entrega hoy mismo
  if (currentDay === 6 && (currentHour < 10 || (currentHour === 10 && currentMinutes === 0))) {
    return "hoy mismo";
  }

  // Sábado después de las 10:00 AM o Domingo en cualquier momento - entrega el lunes
  if ((currentDay === 6 && currentHour >= 10) || currentDay === 0) {
    const daysUntilMonday = currentDay === 6 ? 2 : 1;
    deliveryDate.setDate(today.getDate() + daysUntilMonday);
  }

  const dayName = daysOfWeek[deliveryDate.getDay()];
  const monthName = monthsOfYear[deliveryDate.getMonth()];
  const day = deliveryDate.getDate();

  return `${dayName}, ${day} de ${monthName}`;
}

/* document.addEventListener('DOMContentLoaded', function() {
  const dateElement = document.getElementById('date__estimated');
  if (dateElement) {
    let date = getDeliveryDate();
    dateElement.textContent = date;
  }
}); */

/* --- TEST MAR 16 2025 --- */

function getDeliveryDateB(customDate = null) {
  const daysOfWeek = ["dom", "lun", "mar", "mié", "jue", "vie", "sáb"];
  const monthsOfYear = ["ene", "feb", "mar", "abr", "may", "jun", "jul", "ago", "sep", "oct", "nov", "dic"];
  
  // Obteniendo la fecha y hora actual en la zona horaria de México
  /* let today = luxon.DateTime.now().setZone('America/Mexico_City').toISO(); */
  let today = customDate != null ? luxon.DateTime.fromISO(customDate).setZone('America/Mexico_City').toISO() : luxon.DateTime.now().setZone('America/Mexico_City').toISO();
  
  today = new Date(today);

  const currentHour = today.getHours();
  const currentMinutes = today.getMinutes();
  const currentDay = today.getDay(); 

  let shippingDate = new Date(today);
  let isToday = false;

  // Lunes a Jueves antes de las 2:00 PM - se envía hoy
  if (currentDay >= 1 && currentDay <= 4) { 
    if (currentHour < 14 || (currentHour === 14 && currentMinutes === 0)) {
      isToday = true;
    } else {
      shippingDate.setDate(today.getDate() + 1);
    }
  }

  // Viernes antes de las 2:00 PM - se envía hoy
  if (currentDay === 5 && (currentHour < 14 || (currentHour === 14 && currentMinutes === 0))) {
    isToday = true;
  } else if (currentDay === 5) {
    shippingDate.setDate(today.getDate() + 1);
  }

  // Sábado antes de las 10:00 AM - se envía hoy
  if (currentDay === 6 && (currentHour < 10 || (currentHour === 10 && currentMinutes === 0))) {
    isToday = true;
  } else if (currentDay === 6 || currentDay === 0) {
    const daysUntilMonday = currentDay === 6 ? 2 : 1;
    shippingDate.setDate(today.getDate() + daysUntilMonday);
  }

  // Calcular la fecha de entrega en un rango de 1 a 4 días hábiles
  let minDeliveryDate = new Date(shippingDate);
  let maxDeliveryDate = new Date(shippingDate);

  let addedDays = 0;
  while (addedDays < 4) {
    maxDeliveryDate.setDate(maxDeliveryDate.getDate() + 1);
    if (maxDeliveryDate.getDay() !== 0 && maxDeliveryDate.getDay() !== 6) {
      addedDays++;
    }
  }
  
  minDeliveryDate.setDate(minDeliveryDate.getDate() + 1);
  while (minDeliveryDate.getDay() === 0 || minDeliveryDate.getDay() === 6) {
    minDeliveryDate.setDate(minDeliveryDate.getDate() + 1);
  }

  const shippingDayName = daysOfWeek[shippingDate.getDay()];
  const shippingMonthName = monthsOfYear[shippingDate.getMonth()];
  const shippingDay = shippingDate.getDate();
  
  const minDeliveryDayName = daysOfWeek[minDeliveryDate.getDay()];
  const minDeliveryMonthName = monthsOfYear[minDeliveryDate.getMonth()];
  const minDeliveryDay = minDeliveryDate.getDate();

  const maxDeliveryDayName = daysOfWeek[maxDeliveryDate.getDay()];
  const maxDeliveryMonthName = monthsOfYear[maxDeliveryDate.getMonth()];
  const maxDeliveryDay = maxDeliveryDate.getDate();

  const shippingText = isToday ? "hoy mismo" : `${shippingDayName} ${shippingDay} ${shippingMonthName}`;
  const deliveryText = `${minDeliveryDayName} ${minDeliveryDay} ${minDeliveryMonthName} - ${maxDeliveryDayName} ${maxDeliveryDay} ${maxDeliveryMonthName}`;
  
  return { shippingText, deliveryText };
}

/* document.addEventListener('DOMContentLoaded', function() {
  const dateElement = document.getElementById('date__estimated');
  const deliveryElement = document.getElementById('estimated__delivery');
  if (dateElement && deliveryElement) {
    let { shippingText, deliveryText } = getDeliveryDate();
    dateElement.textContent = shippingText;
    deliveryElement.textContent = deliveryText;
  }
}); */

function updateEstimatedDates(customDate = null) {
  const dateElement = document.getElementById('date__estimated');
  const deliveryElement = document.getElementById('estimated__delivery');
  if (dateElement && deliveryElement) {
    let { shippingText, deliveryText } = getDeliveryDateB(customDate);
    dateElement.textContent = shippingText;
    deliveryElement.textContent = deliveryText;
  }
}

document.addEventListener('DOMContentLoaded', function() {
  updateEstimatedDates();

  // Crear y agregar el input para test mode
  const inpteDateTime = document.getElementById('test-date-picker');

  inpteDateTime.addEventListener('change', function() {
    if (inpteDateTime.value) {
      updateEstimatedDates(inpteDateTime.value);
    } else {
      updateEstimatedDates();
    }
  });
});